// @NOTE we'll probably have to eventually organize eveyrthing in this file.
import { type ClassValue, clsx } from 'clsx';
import dynamic from 'next/dynamic';

import { CreditCardEnum } from '@sola/schema/dotcom/checkout/billingInfo.js';

/**
 * Little utility to check if we are on desktop.
 * Thought it was cleaner to check for desktop than something like isOnDevice?
 */
export const isOnDesktop = () =>
  typeof matchMedia !== 'undefined' && matchMedia('(hover: hover)').matches;

/**
 * Classname utility where we can swap and add additional utilities.
 */
export const cn = (...inputs: ClassValue[]) => {
  return clsx(inputs);
};

/**
 * Lazy loading utility for react components.
 * @see https://nextjs.org/docs/pages/building-your-application/optimizing/lazy-loading
 */
export const lazy = dynamic;

/**
 * Normalize all phone numbers displayed throughout components.
 *
 * This is a very simplistic approach based on immmediate needs for US numbers.
 * Third-party libs seemed to either be poorly maintained or require
 * large imports to handle formatting.
 */
export const formatPhone = (str: string) => {
  const digity = str.replace(/\D/g, '').slice(0, 10);
  return `(${digity.slice(0, 3)}) ${digity.slice(3, 6)}-${digity.slice(6, 10)}`;
};

export const formatCreditCard = (
  cardNumber: string,
  maskChar: string = 'X',
  cardType: CreditCardEnum = CreditCardEnum.NA,
) => {
  const lastFourDigits = cardNumber.slice(-4);
  let ccNumber = cardNumber;
  if (cardNumber.length < 10) {
    if (cardType === CreditCardEnum.Amex) {
      ccNumber = `0000 000000 0${lastFourDigits}`;
    } else {
      ccNumber = `0000 0000 0000 ${lastFourDigits}`;
    }
  }
  return `${ccNumber.replace(/\d/g, maskChar).substring(0, ccNumber.length - 4)}${lastFourDigits}`;
};

/**
 * Hide/remove credit card numbers in a string.
 * @param value The string value to search for CC numbers.
 * @param replaceValue The value to replace CC numbers with.
 * @returns A new string without CC values.
 */
export const removeCreditCardNumbers = (value: string, replaceValue = '') => {
  if (!value || value.length < 13) {
    return value;
  }

  const matches = value.match(/(?:\d[ -]*?){13,16}/g);
  if (!matches) {
    return value;
  }

  let newValue = value;
  matches.forEach((match) => {
    newValue = newValue.replace(match, replaceValue);
  });

  return newValue;
};
